export type EngineFamily = "grid" | "combat" | "motion";

export type GameId =
  | "stack-and-block"
  | "payload-runner"
  | "corridor-zero"
  | "rogue-app-city"
  | "latency-league"
  | "sector-403"
  | "one-client-rider"
  | "packet-pilot"
  | "phish-quest"
  | "ddos-bastion";

export interface GameDefinition {
  readonly id: GameId;
  readonly title: string;
  readonly product: string;
  readonly family: EngineFamily;
  readonly summary: string;
  readonly controls: string;
  readonly playable: boolean;
}

export const gameCatalog: readonly GameDefinition[] = [
  {
    id: "stack-and-block",
    title: "Stack & Block",
    product: "Data Loss Prevention Puzzle",
    family: "grid",
    summary: "Match data cards and clear flagged payloads before the policy queue fills.",
    controls: "Move with arrows or A/D. Drop with Space.",
    playable: false,
  },
  {
    id: "payload-runner",
    title: "Payload Runner",
    product: "Browser Isolation Side-Scroller",
    family: "grid",
    summary: "Carry a clean payload through an isolated session lane.",
    controls: "Move with arrows or WASD. Jump with Space.",
    playable: false,
  },
  {
    id: "corridor-zero",
    title: "Corridor Zero",
    product: "Access / Zero Trust FPS",
    family: "combat",
    summary: "Verify trusted gates and intercept denied requests in a policy corridor.",
    controls: "Move W/S or Up/Down. Turn A/D or Left/Right (Shift to strafe). Aim with pointer. Fire with click or Space.",
    playable: true,
  },
  {
    id: "rogue-app-city",
    title: "Rogue App City",
    product: "CASB Pursuit",
    family: "combat",
    summary: "Track risky application traffic across a shifting city grid.",
    controls: "Drive with arrows or WASD. Scan with Space.",
    playable: false,
  },
  {
    id: "latency-league",
    title: "Latency League",
    product: "Digital Experience Racing",
    family: "motion",
    summary: "Read route signals, avoid degraded lanes, and hold the fastest clean line.",
    controls: "Steer with arrows or A/D. Boost with Space.",
    playable: false,
  },
  {
    id: "sector-403",
    title: "Sector 403",
    product: "Gateway Rail Shooter",
    family: "combat",
    summary: "Clear blocked requests and break a rogue policy core.",
    controls: "Aim with pointer or arrows. Fire with click or Space.",
    playable: false,
  },
  {
    id: "one-client-rider",
    title: "One Client Rider",
    product: "Device Posture Road Race",
    family: "motion",
    summary: "Maintain device health while racing through posture checkpoints.",
    controls: "Steer with arrows or A/D. Stabilize with Space.",
    playable: false,
  },
  {
    id: "packet-pilot",
    title: "Packet Pilot",
    product: "Magic WAN Flight",
    family: "motion",
    summary: "Fly a healthy route through a changing network of path signals.",
    controls: "Fly with arrows or WASD. Boost with Space.",
    playable: false,
  },
  {
    id: "phish-quest",
    title: "Phish Quest",
    product: "Email Security Adventure",
    family: "grid",
    summary: "Inspect message clues and quarantine dangerous routes.",
    controls: "Navigate with arrows. Inspect with Space.",
    playable: false,
  },
  {
    id: "ddos-bastion",
    title: "DDoS Bastion",
    product: "Network Firewall Tower Defense",
    family: "grid",
    summary: "Place distinct defenses and absorb attack waves before they reach the origin.",
    controls: "Select with pointer or arrows. Place with Space.",
    playable: false,
  },
] as const;
